import { LoadableApp } from 'ui-seeker/core'

const Dashboard = LoadableApp(import('./MainDashboard'))

const DashboardRoutes = [
	{ path: '/dashboard', component: Dashboard, needLogin: true, header: false }
]

export default DashboardRoutes